import request from "../utils/request";

export async function createNewPaymentMethod(newPaymentMethod) {
  return request.post("PaymentMethod/Create", newPaymentMethod);
}
export async function updatePaymentMethod(paymentMethod) {
  return request.post("PaymentMethod/Update", paymentMethod);
}
export async function deletePaymentMethod(id) {
  return request.delete('PaymentMethod/Delete?id=' + id);
}
export async function getPaymentMethodList() {
  return new Promise((resolve, reject) => {
    request.get("PaymentMethod/List").then(response => {
      if (response.status != 200) {
        reject(new Error(response.data.message));
      }
      resolve(response.data);
    }).catch(e => {
      reject(e);
    });
  });
}
